import Component from '../../common/Component';
import ItemList from '../../common/utils/ItemList';

/**
 * The `LogInButtons` component displays a collection of social login buttons.
 */
export default class LogInButtons extends Component {
  view() {
    return m("div", {
      className: "LogInButtons"
    }, this.items().toArray());
  }

  /**
   * Build a list of LogInButton components.
   *
   * @return {ItemList<import('mithril').Children>}
   */
  items() {
    return new ItemList();
  }
}
flarum.reg.add('core', 'forum/components/LogInButtons', LogInButtons);